import React from 'react';
import { TableBodyItem, ProfilePhotoContainer, ProfilePhoto } from './Table.styles';
import { ReactComponent as User } from '../../assets/icons/user.svg';

const FirstTableItem = ({ data, className, image, showImage, onClickInfo }) => {
  return (
    <TableBodyItem className={className} onClick={onClickInfo}>
      {showImage ? (
        image ? (
          <ProfilePhotoContainer>
            <ProfilePhoto src={image} alt="loginPhoto" />
          </ProfilePhotoContainer>
        ) : (
          <ProfilePhotoContainer>
            <User width={20} height={20} />
          </ProfilePhotoContainer>
        )
      ) : null}

      {data}
    </TableBodyItem>
  );
};

export default FirstTableItem;
